import { render, staticRenderFns } from "./MealBreakButton.vue?vue&type=template&id=5c8719de&"
import script from "./MealBreakButton.vue?vue&type=script&lang=js&"
export * from "./MealBreakButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports